"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminTokenContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.adminTokenContract = c.router({
    getTokenBalanceOfPlayer: {
        method: 'GET',
        path: '/token-balance',
        query: zod_1.z.object({
            playerId: zod_1.z.string(),
        }),
        responses: {
            200: zod_1.z.number(),
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    getTokenTransactionsOfPlayer: {
        method: 'GET',
        path: '/token-transactions',
        query: zod_1.z.object({
            playerId: zod_1.z.string(),
            page: zod_1.z.coerce.number(),
            pageSize: zod_1.z.coerce.number(),
        }),
        responses: {
            200: models_1.ZGetTokenTransactionResponse,
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    awardTokensToPlayer: {
        method: 'POST',
        path: '/award-tokens',
        body: zod_1.z.object({
            playerId: zod_1.z.string(),
            quantity: zod_1.z.coerce.number().min(1),
        }),
        responses: {
            200: zod_1.z.object({
                newBalance: zod_1.z.number(),
            }),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
            404: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    getAllTokenRedemptionOptions: {
        method: 'GET',
        path: '/all-token-redemption-options',
        responses: {
            200: models_1.ZTokenRedemptionOptionsItem.array(),
        },
    },
    updateTokenRedemptionOptionGroupOrder: {
        method: 'POST',
        path: '/update-redemption-option-group-order',
        body: zod_1.z.object({
            group: zod_1.z.string(),
            reorderedOptionIds: zod_1.z.array(zod_1.z.coerce.number()),
        }),
        responses: {
            200: models_1.ZTokenRedemptionOptionsItem.array(),
            400: zod_1.z.object({
                message: zod_1.z.string(),
            }),
        },
    },
    updateTokenRedemption: {
        method: 'PATCH',
        path: '/token-redemption/:id',
        pathParams: zod_1.z.object({ id: zod_1.z.string() }),
        body: zod_1.z.object({
            tokenRedemption: models_1.ZTokenRedemptionInsert.pick({
                notes: true,
            }),
        }),
        responses: {
            200: zod_1.z.object({ tokenRedemption: models_1.ZTokenRedemptionSelect }),
            400: c.type(),
        },
    },
}, {
    pathPrefix: '/admin',
    commonResponses: {
        401: c.type(),
        403: c.type(),
    },
});
//# sourceMappingURL=token.admin.contract.js.map